// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3YDJJ","input":"styles_input__18RLl"};